import { Button } from '@mui/material';
import { CameraIcon } from 'lucide-react';
import React from 'react';

export const ToggleCameraView = ({ showVideo, setShowVideo }) => {
  const handleToggleVideo = () => {
    setShowVideo(!showVideo);
  };
  return (
    <Button size="small" startIcon={<CameraIcon size={16} />} onClick={handleToggleVideo}>
      Toggle Camera View
    </Button>
  );
};
